import {Color} from "@/lib/styles";
import {useQuery} from "@tanstack/react-query";
import {ServerInfo} from "@/lib/types";
import {dataRetryPolicy, fetchBackend} from "@/lib/backend";
import Header from "@/lib/components/Header";
import Message from "@/lib/components/Message";
import {ActivityIndicator, Platform} from "react-native";
import ErrorMessage from "@/lib/components/ErrorMessage";
import * as Application from 'expo-application';
import MarkdownPage from "@/lib/components/MarkdownPage";

const markdownData = `
# Eventlista

## Hvem står bak?
Eventlista eies av [Sjøsett AS](https://sjøsett.no), som består av:

*Kim Tore Jensen*, daglig leder og systemutvikler. Selvutdannet og bidragsyter til fri programvare, med 20 års erfaring innen utvikling og drift. Spiller musikk og deltar i frivillig arbeid.

*Alexander Lillevik*, designer med lang erfaring innen innholdsformidling og konseptutvikling. Utdannet ved KHiB og har jobbet over 10 år i TV 2.

## Kontakt oss
Vi har [chat på Discord](https://discord.gg/ecDHBCNgjq). Her kan du snakke direkte med oss. Følg utviklingen og kom med tilbakemeldinger.

Ellers kan vi også kontaktes via [e-post](mailto:hei@eventlista.no).

*Sist oppdatert: 11. april 2026*

## Teknisk info
`;

export default function DebugScreen() {
    const {data, isLoading, error} = useQuery<ServerInfo>({
        queryKey: ['server'],
        queryFn: () => fetchBackend(`/server`, "GET"),
        retry: dataRetryPolicy,
    });

    return (
        <MarkdownPage markdown={markdownData}>
            <Header title={"App-versjon"}/>
            {Platform.OS === "web" && <Message text={`Web`}/>}
            {Platform.OS !== "web" && <Message text={`${Application.nativeApplicationVersion} ( build ${Application.nativeBuildVersion} )`}/>}

            <Header title={"Server-versjon"}/>
            {data && <Message text={data.version}/>}
            {isLoading && <ActivityIndicator color={Color.PrimaryText} size={"small"}/>}
            {error && <ErrorMessage error={error}/>}
        </MarkdownPage>
    )
}